import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Primitives';


// === ДАННЫЕ ===
const partnersData = {
  title: 'ДЛЯ ПАРТНЕРІВ',
  subtitle: 'Реальна співпраця. Помітний результат.',
  description:
    'Ми будуємо довгострокові партнерства з брендами та агенціями по всьому світу. Працюємо прозоро, системно й орієнтовано на результат.',
  benefits: [
    'Доступ до ретельно відібраної бази професійних моделей',
    'Супровід і комунікація на всіх етапах співпраці',
    'Гнучкі та зрозумілі умови під різні задачі',
    'Міжнародні контакти та вихід на глобальний ринок',
    'Практичний досвід роботи з відомими брендами',
    'Повний цикл організації та керування проєктами'
  ],
  partnerLogos: [
    { name: 'Anastasia Date', img: '/partners/anastasiadate.png' },
    { name: 'Dream Singles', img: '/partners/dreamsingles.png' },
    { name: 'Find Bride', img: '/partners/findbride.png' },
    { name: 'Place To Chat', img: '/partners/placetochat.png' },
    { name: 'Lada Date', img: '/partners/ladadate.png' },
    { name: 'Charm', img: '/partners/charm.png' },
    { name: 'Dating', img: '/partners/dating.png' },
    { name: 'Victoria Club', img: '/partners/vc.png' }
  ]
}; // ✅ ВОТ ЭТОГО НЕ ХВАТАЛО


const Partners = () => {
  return (
    <div className="bg-black min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(16,185,129,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(16,185,129,0.03)_1px,transparent_1px)] bg-[size:50px_50px]" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl" />
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              {partnersData.title}
            </h1>
            <p className="text-2xl text-emerald-500 mb-8">
              {partnersData.subtitle}
            </p>
            <p className="text-gray-400 text-lg leading-relaxed">
              {partnersData.description}
            </p>
          </div>
        </div>
      </section>


      {/* Benefits Section */}
      <section className="py-16 bg-zinc-950">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center">
              Чому обирають BMGroup
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              {partnersData.benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 bg-white/5 border border-white/10 p-5 rounded-xl hover:bg-white/10 transition-all duration-300"
                >
                  <div className="flex-shrink-0 w-7 h-7 rounded-full bg-emerald-500/20 flex items-center justify-center mt-0.5">
                    <Check className="text-emerald-500 w-4 h-4" />
                  </div>
                  <p className="text-gray-200 leading-relaxed">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

			  {/* Partnership Process */}
			  <section className="py-16 bg-black">
				<div className="container mx-auto px-4">
				  <div className="max-w-5xl mx-auto">
					<h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
					  Як почати співпрацю
					</h2>
					<div className="grid md:grid-cols-3 gap-8">
					  <div className="text-center group">
						<div className="w-20 h-20 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-emerald-500/20 transition-colors">
						  <span className="text-3xl font-bold text-emerald-500">1</span>
						</div>
						<h3 className="text-white text-xl font-bold mb-3">Контакт</h3>
						<p className="text-gray-400">
						  Зв'яжіться з нами через форму або телефон
						</p>
					  </div>
					  <div className="text-center group">
						<div className="w-20 h-20 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-emerald-500/20 transition-colors">
						  <span className="text-3xl font-bold text-emerald-500">2</span>
						</div>
						<h3 className="text-white text-xl font-bold mb-3">Обговорення</h3>
						<p className="text-gray-400">
						  Детально обговорюємо ваші потреби та цілі
						</p>
					  </div>
					  <div className="text-center group">
						<div className="w-20 h-20 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-emerald-500/20 transition-colors">
						  <span className="text-3xl font-bold text-emerald-500">3</span>
						</div>
						<h3 className="text-white text-xl font-bold mb-3">Співпраця</h3>
						<p className="text-gray-400">
						  Розпочинаємо продуктивне партнерство
						</p>
					  </div>
					</div>
				  </div>
				</div>
			  </section>

      {/* Featured Partnerships Section */}
      <section className="py-16 bg-zinc-950">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
              Наші партнери
            </h2>
            <p className="text-gray-400 mb-12">
              Ми працюємо з провідними брендами та агенціями по всьому світу
            </p>
				{/* Знайдіть цей блок у вашому коді і замініть його */}
				<div className="grid grid-cols-2 md:grid-cols-4 gap-8">
				  {partnersData.partnerLogos.map((partner, index) => (
					<div
					  key={index}
					  // Трохи збільшимо яскравість контейнера при наведенні для кращого ефекту
					  className="bg-white/5 backdrop-blur-sm border border-white/10 
								 rounded-xl h-28
								 flex items-center justify-center
								 hover:bg-white/10 transition-all duration-300 hover:scale-105 group" // Додали клас 'group'
					>
					  <img
						src={partner.img}
						alt={partner.name}
						// ВАЖЛИВІ ЗМІНИ ТУТ:
						// 1. Прибрали opacity-80
						// 2. Додали brightness-0 invert (робить логотип повністю білим)
						// 3. Додали group-hover:brightness-100 group-hover:invert-0 (повертає колір при наведенні на контейнер)
						className="max-h-16 max-w-[140px] object-contain transition duration-300
								   brightness-0 invert 
								   group-hover:brightness-100 group-hover:invert-0"
					  />
					</div>
				  ))}
				</div>
          </div>
        </div>
      </section>

		{/* CTA Section */}
		<section className="py-24 bg-black">
		  <div className="container mx-auto px-4">
			<div className="max-w-4xl mx-auto text-center">
			  <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
				Готові стати партнером?
			  </h2>
			  <p className="text-gray-400 text-xl mb-8">
				Зв'яжіться з нами та обговорімо можливості співпраці!
			  </p>
			  
			  <div className="flex flex-col sm:flex-row gap-4 justify-center">
				<a
				  href="https://t.me/bmg_managerrrr"
				  target="_blank"
				  rel="noopener noreferrer"
				>
				  <Button
					size="lg"
					className="bg-emerald-500 hover:bg-emerald-600 text-white font-medium px-10 py-6 text-lg transition-all duration-300 hover:scale-105 w-full sm:w-auto"
				  >
					НАПИСАТИ В TELEGRAM
				  </Button>
				</a>
				<Link to="/contact">
				  <Button
					size="lg"
					className="bg-white/5 hover:bg-white/10 border border-white/20 text-white font-medium px-10 py-6 text-lg transition-all duration-300 w-full sm:w-auto"
				  >
					ЗАПОВНИТИ ФОРМУ
				  </Button>
				</Link>
			  </div>

			</div>
		  </div>
		</section>
    </div>
  );
};

export default Partners;